import {Card} from 'reactstrap'

import Loader from '../../../../../Components/Common/Loader'
import SKUTable from './sku-table/SKUTable'

export const SKUTab = ({isLoading}) => {
  return (
    <Card className="card-form p-3 mb-5">
      {isLoading ? <Loader /> : <SKUTable />}
    </Card>
  )
}
